import { call, put, takeLatest } from 'redux-saga/effects'
import { FETCH_BULLETIN } from './constants'
import { fetchBulletin } from './actions'
import { apiFetchBulletin } from './services'

function* fetchBulletinWorker(action) {
  const response = yield call(apiFetchBulletin, action.page, action.limit)
  if (Array.isArray(response.messages)) {
    yield put(fetchBulletin.success(response.messages, response.totalCount))
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_BULLETIN.REQUEST, fetchBulletinWorker)
}
